import { render, staticRenderFns } from "./CarrierProducts.vue?vue&type=template&id=2006d5e1&"
import script from "./CarrierProducts.vue?vue&type=script&lang=js&"
export * from "./CarrierProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports